import React from 'react';

export enum TabVariant {
  Default = 'default',
  Segmented = 'segmented'
}

export interface TabsComponentProps {
  value: string;
  variant?: TabVariant;
  segmentedCompact?: boolean;
  tabs: {
    label: string;
    value: string;
    flag?: string;
    icon?: React.ReactNode;
    showDeleteIcon?: boolean;
    showEditIcon?: boolean;
    dataTour?: string;
  }[];
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  disabled?: Record<string, boolean>;
  onDelete?: (tabValue: string) => void;
  onEdit?: (tabValue: string) => void;
}

export const infoCenterTabsData = [
  { label: 'tab_label_categories', value: 'categories' },
  { label: 'tab_label_informations', value: 'informations' }
];

export const digitalSignageTabsData = [
  { label: 'tab_label_devices', value: 'devices' },
  { label: 'tab_label_groups', value: 'device-groups' },
  { label: 'tab_label_screens', value: 'screens' },
  { label: 'tab_label_events', value: 'events' },
  { label: 'tab_label_playlists', value: 'playlists' }
];

export const entertainmentTabsData = [
  { label: 'tab_label_live_tv', value: 'live-tv' },
  { label: 'tab_label_movies', value: 'movies' },
  { label: 'tab_label_series', value: 'series' },
  { label: 'tab_label_music', value: 'music' },
  { label: 'tab_label_radio', value: 'radio' },
  { label: 'tab_label_playlists', value: 'playlists' }
];

export const seriesTabData = [
  { label: 'tab_label_details', value: 'details' },
  { label: 'tab_label_media', value: 'media' }
];

export const departmentsAndUnitsTabsData = [
  { label: 'tab_label_departments', value: 'departments' },
  { label: 'tab_label_units', value: 'units' }
];

export const promotionsTabsData = [
  { label: 'tab_label_custom', value: 'custom' },
  { label: 'tab_label_service', value: 'service' },
  { label: 'tab_label_product', value: 'product' }
];

export const catalogTabsData = [
  { label: 'tab_label_products_categories', value: 'product-categories' },
  { label: 'tab_label_products', value: 'products' },
  { label: 'tab_label_services', value: 'services' }
];

export const salesTabsData = [
  { label: 'tab_label_orders', value: 'orders' },
  { label: 'tab_label_service_requests', value: 'service-requests' }
];

export const analyticsTabsData = [
  { label: 'tab_label_orders', value: 'orders' },
  { label: 'tab_label_services', value: 'services' },
  { label: 'tab_label_guests', value: 'guests' },
  { label: 'tab_label_platforms', value: 'platforms' },
  { label: 'tab_label_ai_concierge', value: 'ai-concierge' }
];

export const organizationTabsData = [
  { label: 'tab_label_general_info', value: 'general' },
  { label: 'tab_label_branding', value: 'branding' },
  { label: 'tab_label_api_key', value: 'api-key' }
];

export const appBuilderTabsData = [
  { label: 'tab_label_tv_branding', value: 'tv-branding' },
  { label: 'tab_label_tablet_branding', value: 'tablet-branding' },
  { label: 'tab_label_mobile_branding', value: 'mobile-branding' },
  { label: 'tab_label_captive_portal_branding', value: 'captive-portal' }
];

export const hotelWifiTabsData = [
  { label: 'hotel_wifi_tab_sessions', value: 'sessions' },
  { label: 'hotel_wifi_tab_bandwidth_tiers', value: 'bandwidth-tiers' },
  { label: 'hotel_wifi_tab_guests', value: 'guests' },
  { label: 'hotel_wifi_tab_tier_history', value: 'tier-history' }
];

export const aiSettingsTabsData = [
  { label: 'tab_label_configuration', value: 'general' },
  { label: 'tab_label_capabilities', value: 'capabilities' },
  { label: 'tab_label_faq', value: 'faq' }
];
